import { render, staticRenderFns } from "./NursingManagement.vue?vue&type=template&id=53323422&scoped=true"
import script from "./NursingManagement.vue?vue&type=script&lang=js"
export * from "./NursingManagement.vue?vue&type=script&lang=js"
import style0 from "./NursingManagement.vue?vue&type=style&index=0&id=53323422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53323422",
  null
  
)

export default component.exports